var exports = {
  "x": "xe564cbfb--94c3f7--thumbnail",
};

module.exports = exports;
